<template>
    <nav class="flex col-12 justify-between align-middle">
      <router-link to="/">
        <img class="nav-logo" src="../assets/logo2-negative.svg">
      </router-link>
      <div class="mr2 flex">
        <router-link to="/shoutout" class="m2 nav-link">
          <img class="nav-icon" src="../assets/megaphone-1.svg">
        </router-link>
        <!-- <router-link to="/music-wishlist" class="m2 nav-link">
          <img class="nav-icon" src="../assets/music-note.svg">
        </router-link> -->
        <router-link to="/gallery-overview" class="m2 nav-link">
          <img class="nav-icon" src="../assets/gallery.svg">
        </router-link>
      </div>
    </nav>
</template>
<script>
export default {
  name: "Nav",
  data() {
    return {
      session: {},
    };
  },
  components: {
  }
}
</script>
<style>

</style>
